/**
 * @module メッセージダイアログ共通コンポーネント
 */
var mixin = {
  data() {
    return {
      show: false,
    };
  },
  created() {
    this.$mount();
    document.body.appendChild(this.$el);
    this.show = true;
  },
  watch: {
    $browserBack(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.close();
      }
    },
    $route() {
      this.close();
    },
  },
  methods: {
    close() {
      this.show = false;
      setTimeout(() => {
        if (document.body.contains(this.$el)) document.body.removeChild(this.$el);
        this.$destroy();
      }, 200);
    },
  },
};

export default {
  mixins: [mixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    btnName: {
      type: String,
      required: true,
    },
    okAction: {
      type: Function,
      required: true,
    },
    url: {
      type: String,
      required: false,
    },
    lockUpAbnormalAreaInfo: {
      type: Array,
      required: false,
    },
    couldNotChangedStatusMessage: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      okLoadFlag: false,
    };
  },
  /** @type {Methods} */
  methods: {
    /**
     * OKボタン押下時処理
     */
    ok() {
      this.okLoadFlag = true;
      this.okAction();
      this.close();
      this.okLoadFlag = false;
      if (this.url) this.router(this.url);
    },
    router: function (url) {
      this.$router.replace({
        path: url,
      });
    },
    /**
     * リンク押下時処理（戸締り異常地区）
     */
    linkClick(lockUpAbnormal) {
      // 対象地区番号をストアに保存
      this.$store.commit('setDistrictSplitNumber', {
        districtSplitNumber: lockUpAbnormal.districtSplitNumber,
      });
      // お客様番号をストアに保存
      this.$store.commit('setCustomerNumber', {
        customerNumber: lockUpAbnormal.customerNumber,
      });

      this.close();

      // FE-CU13_戸締り確認画面
      this.$router.push('/lockConfirmation');
    },
  },
};
